

export default {
    // 将store中的filter Request对象转化成cruise search request对象
    generateCruiseSearchRequest: (storeFilterRequest, cruiseType) => {
        let cruiseSearchRequest = {
            shipCode: storeFilterRequest.shipCodes.map(item => item.code).join(','),
            sailDate: storeFilterRequest.sailDates.map(item => item.code).join(','),
            sailDays: storeFilterRequest.sailDays.map(item => item.code).join(','),
            departureCodes: storeFilterRequest.departures.map(item => item.code).join(','),
            destinationCodes: storeFilterRequest.destinations.map(item => item.code).join(','),
            tags: storeFilterRequest.tags.map(item => item.code).join(','),
            keywords: storeFilterRequest.keywords || '',
            cruiseSearchType: cruiseType == 'hp' ? 1: 2,
            username: storeFilterRequest.username,
            offset: storeFilterRequest.offset || 0,
            limit: storeFilterRequest.limit || 10,
            orderBysailDate: storeFilterRequest.orderBysailDate > 0 ? storeFilterRequest.orderBysailDate: 0,
            orderByPrice: storeFilterRequest.orderByPrice > 0 ? storeFilterRequest.orderByPrice:0,
            orderBySailDays: storeFilterRequest.orderBySailDays>0?storeFilterRequest.orderBySailDays:0,
            orderByAmountPerNight: storeFilterRequest.orderByAmountPerNight>0?storeFilterRequest.orderByAmountPerNight:0,
            tikTokCode: storeFilterRequest.tikTokCode || '',
            tripMode: Array.isArray(storeFilterRequest.tripModes) ? storeFilterRequest.tripModes.map(item => item.code).join(',') : '',
        }
        return cruiseSearchRequest
    }
}
